<div class="stickyCard">
  <div class="d-flex flex-column">
    <div class="staffNameHeader">
      <div class="font-weight-bold">
        {{ isCreateMode ? ('ADD_NEW_USER' | translate) : (staff.firstName + ' ' + staff.familyName) }}
      </div>

      <button (click)="initClosingEditCard()" class="unsetStyles">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="form-content ml-4 mb-4" [ngClass]="staff.updateFailed ? 'mt-5' : 'mt-4'">
      <mat-label class="mr-4 font-weight-bold">{{ "PLATFORM_ROLE" | translate }}:</mat-label>

      <mat-form-field appearance="outline">
        <mat-select
          #roleSelect
          [value]="staff.staffRole"
          (selectionChange)="updateStaffRole(roleSelect, staff)"
          >
          <mat-option [value]="mode === 'federated' ? 0 : 5" class="hideMatOptionCheckbox">User</mat-option>
          <mat-option [value]="mode === 'federated' ? 95 : 130" class="hideMatOptionCheckbox">Landing page user</mat-option>
        </mat-select>
      </mat-form-field>

      @if (staff.updateFailed) {
        <p class="text-danger role-select-error">
          {{ "ROLE_UPDATE_ERROR" | translate }}
        </p>
      }
    </div>

    <mat-divider class="mx-3 wd-50"></mat-divider>

    <div class="mx-4">
      <p class="font-weight-bold mt-4 mb-3">{{ "CLIENT_ACCESS" | translate }}:</p>

      @for (added of staff.addedCompanies; track added; let r_id = $index) {
        <div class="d-flex align-items-center mb-4">
          <mat-form-field appearance="outline" class="ml-4">
            <!-- <mat-label>{{ "COMPANY" | translate }}</mat-label> -->
            <mat-select [(value)]="added.company">
              @for (customer of customers; track customer) {
                <mat-option
                  class="hideMatOptionCheckbox"
                  value="{{ customer.companyId }}"
                  [disabled]="isCompanyAdded(customer.companyId) && customer.companyId !== added.company"
                  >
                  {{ customer.company }} ({{ customer.companyId }})
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="ml-4">
            <!-- <mat-label>{{ "ROLE" | translate }}</mat-label> -->
            <mat-select [(value)]="added.role" [disabled]="!added.company">
              @for (role of roles; track role; let i = $index) {
                <mat-option
                  class="hideMatOptionCheckbox"
                  value="{{ role.value }}"
                  >
                  {{ role.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (staff.addedCompanies.length > 1 && added.new) {
            <button
              type="button"
              class="ml-4 unsetStyles"
              data-dismiss="modal"
              (click)="startRemovingCompany(r_id)"
              >
              <i class="fa-duotone fa-xmark fa-lg"></i>
            </button>
          }
          @if (staff.addedCompanies.length >= 1 && !added.new) {
            <button
              class="ml-4 unsetStyles"
              (click)="openDialog(staff, added.company)"
              >
              <i class="fa-duotone fa-trash-can fa-lg"></i>
            </button>
          }
        </div>
      }

      <button class="btn btn-light wd-50" (click)="startAddingCompany()">
        + {{ "ADD_CLIENT" | translate }}
      </button>
      <p *ngIf="staff.roleValidationFailed" class="text-danger mt-2">
        {{ "COMPANY_SELECTED_WITHOUT_ROLE" | translate }}
      </p>
    </div>
    <div class="mx-4 mt-4" *ngIf="mode === 'non-federated'">
      <div *ngIf="!isCreateMode" class="mb-2">
      <p class="font-weight-bold mb-2">
        {{ "STAFF_ID" | translate }}
      </p> 
      <div class="form-control-plaintext p-0">
        {{ staff.staffId }}
      </div>
    </div>
      <p class="font-weight-bold mb-2">
        {{ "FIRST_NAME" | translate }}
      </p>
      <div>
        <input
          type="text"
          class="form-control form-control-sm"
          id="first-name"
          name="firstName"
          [(ngModel)]="staff.firstName"
        />
      </div>

      <p class="font-weight-bold mb-2 mt-2">
        {{ "LAST_NAME" | translate }}
      </p>
      <div>
        <input
          type="text"
          class="form-control form-control-sm"
          id="last-name"
          name="lastName"
          [(ngModel)]="staff.familyName"
        />
      </div>
 

    <mat-divider class="my-4 w-100 mx-auto"></mat-divider>
  
    <p class="font-weight-bold mb-2 mt-2">{{ "USERNAME" | translate }} <span>*</span></p>
    <div>
      <input
        type="text"
        class="form-control form-control-sm"
        id="username"
        name="userName"
        [(ngModel)]="staff.username"
        #username="ngModel"
        required
        (blur)="checkUsernameAvailability()"
      />
       <!-- REQUIRED -->
    @if (!username.value && username.errors?.required) {
      <span class="text-danger">
        {{ "REQUIRED_FIELD" | translate }}
      </span>
    }

    <!-- USERNAME IN USE -->
    @if (usernameInUse) {
      <span class="text-danger">
        {{ "USERNAME_IN_USE" | translate }}
      </span>
    }
    </div>

    <!-- password -->
    <div class="mt-3">
      <label>
        <strong>{{ (isCreateMode ? 'PASSWORD' : 'CHANGE_PASSWORD') | translate }}</strong>
      </label>

    <!-- mismatch -->
    <div class="form-group mt-2" *ngIf="staff.password !== staff.confirmPassword">
      <span class="text-danger">
        {{ 'PASSWORDS_DONT_MATCH' | translate }}
      </span>
    </div>

    <!-- password -->
    <div class="form-group mt-2">
      <input
        type="password"
        class="form-control form-control-sm"
        placeholder="{{ 'NEW_PASSWORD' | translate }}"
        [(ngModel)]="staff.password"
      />
    </div>

    <!-- confirm -->
    <div class="form-group">
      <input
        type="password"
        class="form-control form-control-sm"
        placeholder="{{ 'CONFIRM_NEW_PASSWORD' | translate }}"
        [(ngModel)]="staff.confirmPassword"
      />
    </div>
  </div>

  <p class="font-weight-bold mb-2 mt-2">
    {{ "EMAIL" | translate }}
  </p>
  
  <div>
    <input
      type="text"
      class="form-control form-control-sm"
      id="email"
      name="email"
      [(ngModel)]="staff.email"
      #email="ngModel"
      email
    />
  
    @if (email.invalid && (email.touched || email.dirty)) {
      <span class="text-danger">
        {{ "INVALID_EMAIL" | translate }}
      </span>
    }
  </div>

    <!-- Hidden for now, taken back into use later -->
    <div *ngIf="showFederationConversion && mode === 'non-federated' && !isCreateMode">
      <p class="font-weight-bold mb-2 mt-2">
        {{ "CONVERT_TO_FEDERATED_USER" | translate }}
      </p>
      <p class="font-weight-bold mb-2 mt-2">
        {{ "STRONG_AUTHENTICATION_USER" | translate }}
      </p>
      <mat-form-field class="selector-full-width" appearance="outline">
        <mat-select [(ngModel)]="staff.identityUsername">
          <mat-option [value]="null">— {{ 'NONE' | translate }} —</mat-option>
          <mat-option
            *ngFor="let identity of identityUsers"
            [value]="identity.username"
          >
            {{ identity.firstname }} {{ identity.familyName }} ({{ identity.username }})
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  </div>
  <div class="d-flex align-items-center mt-1 mb-2">
    <button class="btn btn-primary ml-4 mt-5 mr-2 mb-3" (click)="startMovingSelected()" [disabled]="mode === 'non-federated' && !staff.username?.trim() || usernameInUse ||
    (staff.email && !staff.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/))">
      {{ "SAVE" | translate }}
    </button>
    <button class="btn mt-5 mb-3" (click)="initClosingEditCard()">
      {{"CANCEL" | translate}}
    </button>
  
    <button
      class="btn btn-outline-danger mt-5 mb-3 ml-auto mr-4"
      (click)="deleteConfirmation = true"
      *ngIf="mode === 'non-federated' && !deleteConfirmation && !isCreateMode"
    >
      {{'DELETE_USER' | translate}}
    </button>
  </div>
  
  <!-- delete user confirmation -->
  <div *ngIf="deleteConfirmation && mode === 'non-federated'" class="mx-4 mb-3">
    <p>
      {{ 'STAFF_DELETE_CONFIRMATION' | translate:{
        staff: staff.firstName + ' ' + staff.familyName
      } }}
    </p>
    <button class="btn btn-danger mr-2" (click)="deleteLandingPageUser()">
      {{ 'DELETE' | translate }}
    </button>
    <button class="btn btn-secondary" (click)="deleteConfirmation = false">
      {{ 'CANCEL' | translate }}
    </button>
    <p *ngIf="deleteError" class="text-danger mt-2">
      {{ 'DELETE_FAILED' | translate }}
    </p>
  </div>
</div>
